var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    style: {
      enableBackground: "new 0 0 88 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FBB49B;}\r\n\t.st1{fill:none;stroke:#030000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.1,59.3c7.6-13.9,20.1-37.6,22.1-42.2S86,6.6,76.1,5.9S17.3,6,6.4,6.6C3,6.8,1.7,9.1,2.5,12.1 c1,3.9,3.9,11.3,6.4,16.5c6.1,12.3,11.8,24,16.5,32.5C31.7,72.3,39,84.9,43.2,84.9C47,84.9,53.8,74.3,62.1,59.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.3,25.8c3.8,0.3,7.6-1,10.4-3.5c0.8-0.7,1.5-2.3,0.5-2.8c-0.9-0.4-1.7,0.8-1.9,1.8 c-0.9,3.9-0.6,8.1,0.7,11.9c1.4,3.9,4.1,7.7,3.9,11.9c-0.1,2-0.7,3.9-1.4,5.7c-3.6,10.8-5.9,22.5-2.7,33.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.5,26.9c-3.6-0.6-6.9-2.5-9.2-5.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.5,24.4c1.2,5.7-2.6,11.2-3.1,16.9c-0.3,4,0.9,7.9,1.8,11.8c2,8.8,2.2,18.1,0.6,27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,26c1.8,1.3,4.1,1.8,6.4,1.8c2.2,0,5.3-1.1,5.3-1.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.1,26.9c2.5,1,8,0.8,10.5-0.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,48.1c8.3-0.2,16.6-0.5,24.9-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.3,61.2c-1,9.1-3.9,17.9-8.5,25.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,60.9c2.8,0.7,6-0.3,8-2.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,61.2c-0.4,8.9,2.7,17.8,6.3,25.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,13.5C25.3,8.6,33,6.7,39.4,8.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.4,1.1c0.3,2.3,0.6,4.6,1,6.9c0.1,0.7,0.2,1.5-0.1,2.1c-0.3,0.6-1.2,1.1-1.8,0.7c-0.3-0.2-0.5-0.7-0.5-1.1 c0-1.5,1.8-2.3,3.3-2.5c6.2-0.9,12.7,2.2,16.1,7.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.4,78.3c4.2,0.3,8.3,0.8,12.4,1.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,80c3-0.6,6.1-1.2,9.1-1.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,8.5c1.1,3,2.8,5.9,5.3,7.9s5.9,3.1,9,2.3c2.2-0.6,4.1-2,5.5-3.8c1.4-1.8,2.4-3.9,3-6.1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,9c-0.1,1.7-0.3,3.4-0.4,5.2c-0.2,2.7,0.1,8.2,2.5,10.1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.3,16.4c1.2-2.5,1.7-5.4,1.5-8.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuso);
export default __webpack_public_path__ + "static/media/muso.b1af8aeaa30f14bc5f69cf46540cb6ff.svg";
export { ForwardRef as ReactComponent };